import React, { Component } from 'react';
import Radium from 'radium';

import Header from "./Header";
import SettingSection from './SettingSection';
import UserServices from '../services/UserServices';
import Button from "./Button";
import BubbleSettings from './BubbleSettings';

class Settings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showEditBubble: false,
			loading: true
		};
	}

	componentDidMount() {
		// Reload the settings
		this.reload();
	}

	async reload() {
		const settings = await UserServices.loadUserSettings();
		this.setState({
			settings: settings,
			loading: false
		});
	}

	updateSettings(settings) {
		this.setState({
			settings: settings
		});
	}

	renderContent() {
		if (this.state.loading) {
			return null;
		}

		return (
			<div style={this.localStyles().mainSection}>
				<div style={this.localStyles().content}>
					<SettingSection
						style={this.props.style}
						title="Bubbles"
						pro={true}
						settings={this.state.settings}
						onUpdateSettings={(settings) => this.updateSettings(settings)}
						onOff={() => UserServices.savePreference(UserServices.DEFAULT_BUBBLE_PREFERENCE, null)}
						preference={UserServices.BUBBLES_ON_PREFERENCE}
						description="Bubbles let you have different task lists for different contexts. E.g. one for work, one for personal."
					>
						<BubbleSettings
							style={this.props.style}
							bubbles={this.props.bubbles}
							onReloadUserData={this.props.onReloadUserData}
						/>
					</SettingSection>
					<SettingSection
						style={this.props.style}
						title="Breakdowns"
						pro={true}
						settings={this.state.settings}
						onUpdateSettings={(settings) => this.updateSettings(settings)}
						preference={UserServices.BREAKDOWNS_ON_PREFERENCE}
						description="Breakdowns let you breakdown your tasks into three further sub tasks"
					/>
					<SettingSection
						style={this.props.style}
						title="Confetti"
						pro={false}
						settings={this.state.settings}
						onUpdateSettings={(settings) => this.updateSettings(settings)}
						preference={UserServices.CONFETTI_ON_PREFERENCE}
						description="Show confetti when you complete all the tasks in a day (or not)."
					/>
					<SettingSection
						style={this.props.style}
						title="Dynamic Title Bar"
						pro={true}
						settings={this.state.settings}
						onUpdateSettings={(settings) => this.updateSettings(settings)}
						preference={UserServices.DYNAMIC_TITLE_BAR_ON_PREFERENCE}
						description="Show an emoji based summary of your completed tasks in the title bar"
					/>
					
				</div>

				<Button
					title="Done"
					width="100%"
					style={this.props.style}
					onClick={() => window.location.href = "/"}
				/>	
			</div>
		);
	}

	render() {
		return (
			<div style={this.props.style.global.screenContainer}>
				<Header 
					style={this.props.style}
					subscribed={this.props.subscribed}
					/>
				
				<h1>Settings</h1>
				{this.renderContent()}

			</div>
		)
	}

	localStyles() {
		return {
			mainSection: {
				marginTop: 50,
				width: "80%",
				maxWidth: 500,
				paddingLeft: 30,
				paddingRight: 30,
				paddingBottom: 100
			},
			content: {
				display: "flex",
				flexDirection: "column",
				alignItems: "flex-start",
				justifyContent: "flex-start",
				
			}
		}
	}
}

export default Radium(Settings);


// WEBPACK FOOTER //
// ./src/components/Settings.js